import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {HttpApiService} from '../../../services/http-api.service';
import {EndpointsService} from '../../../services/endpoints.service';
import {Constants} from '../../../services/constants';
import {SharedService} from '../../../services/shared.service';
import {UserService} from '../../../services/user.service';
import {ModalDirective} from 'ngx-bootstrap';
import {AlertMessageComponent, AlertType} from '../../../shared/alert-message/alert-message.component';
import {TenantService} from "../../../services/tenant.service";


@Component({
  selector: 'app-rfq',
  templateUrl: './rfq.component.html',
  styleUrls: ['./rfq.component.scss']
})
export class RFQComponent implements OnInit {
  lead;
  isCreated = false;
  hasError = false;
  noEmail = false;
  errorMessage: any;
  isUploading = false;
  quote: any = {};
  file: any = {};
  profile: any = {};
  pricingPlans: any;
  planId: any;
  selectedPricingPlan: any = {};
  selectedPricingTier = 1;
  quantity: number = 1;
  agreeToTerms: boolean = false;
  showLicenseModal: boolean = false;
  isLoginModal: boolean = false;
  quoteOptions: Array<any>;
  addOnOptions: Array<any>;
  selectedItems = [];
  selectedAddOnItems = [];
  isPricingAvailable = false;
  optionsModel: any = {quoteOptions: [], quoteTypes: []};
  addOnsModel: any = {addOnOptions: [], addOnTypes: []};

  registerLink = Constants.ORIGIN() + '/signup';
  tenant;
  buyer = {
    user: {},
    companyName: '',
    primaryContact: '',
    department: ''
  };
  newRow: any = {};
  tempProxyBuyer;
  @ViewChild('loginModal') public loginModal: ModalDirective;
  @ViewChild('modal') public modal: ModalDirective;

  constructor(private api: HttpApiService,
              private sharedService: SharedService,
              private userService: UserService,
              private route: ActivatedRoute,
              private router: Router,
              private endpoints: EndpointsService,
              private tenantService: TenantService) {
  }

  ngOnInit() {
    const self = this;
      self.tenantService.getTenantWithPromise().then((response) => {
        self.tenant = response;
      });
    this.buyer.user = {email: '', address: {city: '', state: '', country: ''}}
    if (this.isLoggedIn()) {
      this.userService.getCurrentUser()
        .then(user => {
          if (!this.route.snapshot.queryParams['rfqId']) {
            this.buyer.user = user;
            this.buyer.companyName = this.buyer.user['buyerCompanyName'];
            this.buyer.primaryContact = this.buyer.user['primaryContact'];
            this.buyer.department = this.buyer.user['buyerDepartment'];
          }
        });
    }
    this.loadData();
  }

  loadData() {
    this.route.queryParams
      .subscribe(data => {
        this.quoteOptions = [{id: 0, name: 'New Customer for Product'},
          {id: 1, name: 'Existing Customer'},
          {id: 2, name: 'New Department/Division'}]
        if (!data['rfqId']) {
          this.quote.buyerUserName = '';
          const profileId = this.sharedService.decodeBase64(data['profileId']);
          this.planId = data['planId'];
          this.profile = this.sharedService.getParameter('selectedProfile');
          this.isPricingAvailable = this.sharedService.getParameter('isPricingAvailable');
          this.profile = this.profile ? this.profile : {};
          this.quote.applicationProfile = {id: this.profile.id};
          this.quote.status = 'PENDING';
          this.quote.statusChangeExplanation = '';
          this.quote.date = new Date();
          this.quote.isRespondToRFP = '';
          this.quote.submissionDeadline = '';
          this.quote.purchaseTimeEstimate = '';
          this.quote.addOns = '';
          this.quote.numberOfUsers = '';
          this.quantity = data['quantity'] ? parseInt(data['quantity'].toString()) : 1;

          if (!this.profile || this.profile.id != profileId) {
            this.api.get(this.endpoints.getPricingPlanWithIdUrl() + '/' + profileId + '?domain=' + Constants.TENANT_ID(), true)
              .subscribe(profile => {
                this.profile = profile;
                this.quote.applicationProfile = {id: this.profile.id};
                this.setSelectedPlan();
              });
          } else {
            this.setSelectedPlan();
          }
        }});
  }

  setSelectedPlan() {
    this.pricingPlans = this.profile.details.pricingPlans;
    this.pricingPlans.forEach(item => {
      if (item.planId === this.planId) {
        this.selectedPricingPlan = item;
        if (this.selectedPricingPlan.publicDisplay.name == 'RFQ_NO_PRICING' ||
          this.selectedPricingPlan.publicDisplay.name == 'RFQ_DISPLAY_PRICING' ||
          this.selectedPricingPlan.registeredBuyerDisplay.name == 'RFQ_NO_PRICING' ||
          this.selectedPricingPlan.registeredBuyerDisplay.name == 'RFQ_DISPLAY_PRICING') {
          this.quote.vendorApprovalRequired = 'YES';
        }
        if (this.selectedPricingPlan.pricingTiers && this.selectedPricingPlan.pricingTiers.length > 0) {
          this.selectedPricingTier = this.selectedPricingPlan.pricingTiers[0].id;
          this.addOnOptions = [];
          this.selectedPricingPlan.pricingTiers[0].addOns.forEach(addOn => {
            this.addOnOptions.push({id: addOn.id, name: addOn.name});
          });

        }
      }
    });
  }

  updateAddOns() {
    this.selectedAddOnItems = [];
    for (const key in this.addOnsModel.addOnOptions) {
      if (this.addOnsModel.addOnOptions.hasOwnProperty(key)) {
        this.selectedAddOnItems.push({id: this.addOnsModel.addOnOptions[key].id});
      }
    }
  }

  selectPricingPlan(planId) {
    this.planId = planId;
    this.setSelectedPlan();
  }

  selectPricingTier(event) {
    console.log(event);
    this.addOnOptions = [];
    this.addOnsModel = {addOnOptions: [], addOnTypes: []};
    this.selectedPricingPlan.pricingTiers.forEach(pricingTier => {
      if (pricingTier.id == event) {
        pricingTier.addOns.forEach(addOn => {
          this.addOnOptions.push({id: addOn.id, name: addOn.name});
        });
      }
    });
  }

  submitQuote(quote) {
    if (this.userService.isLoggedIn() && (this.isBuyer() || this.isReseller())) {
      this.requestQuote(quote, true);
    } else if ((!this.userService.isLoggedIn())) {
      this.requestQuote(quote, false);
    } else {
      this.noEmail = true;
    }
    return false;
  }

  requestQuote(quote, isLoggedIn: boolean) {
    this.isUploading = true;
    this.errorMessage = '';
    this.isCreated = false;
    quote.buyer = this.buyer;
    quote.pricingPlanType = this.selectedPricingPlan.name;
    quote.otherRequirements = quote.otherRequirements ? quote.otherRequirements : 'None';
    quote.pricingPlan = 'NA';
    quote.quoteTypes = this.selectedItems;
    if (this.selectedPricingTier && this.selectedPricingTier > 1) {
      const tier = this.selectedPricingPlan.pricingTiers.filter(item => item.id == this.selectedPricingTier)[0];
      if (tier) {
        quote.pricingPlan = `${tier.price} USD Per ${tier.perUnit}`;
        quote.pricingTier = tier;
      }
    }
    quote.addOns = this.selectedAddOnItems;
    this.api.post(this.endpoints.getRFQUrl('tenantId=' + Constants.TENANT_ID() + '&isBuyerQuote=true'), quote, isLoggedIn)
      .subscribe(res => {
          this.resetValues();
          AlertMessageComponent.open(AlertType.Success, 'Your Quote Request has been successfully submitted');
          this.isCreated = true;
          this.isUploading = false;
        },
        error => {
          this.resetValues();
          this.hasError = true;
          const errorBody = JSON.parse(error._body);
          if (errorBody && errorBody.message) {
            this.errorMessage = errorBody.message;
          } else {
            this.errorMessage = 'Reason unknown!';
          }
          this.isUploading = false;
        })
    return false;
  }

  uploadAttachment(id, isLoggedIn: boolean) {
    const data: any = {};
    data.data = this.file.data;
    data.id = id;
    data.fileName = this.file.name;
    this.api.put(this.endpoints.getRFQAttachmentUrl('tenantId=' + Constants.TENANT_ID()),
      data, isLoggedIn)
      .subscribe(res => {
          this.resetValues();
          this.isCreated = true;
          this.showRFQCreatedAlert();
        },
        error => {
          this.resetValues();
          this.hasError = true;
          this.errorMessage = error;
        });
  }

  uploadLogo(event) {
    const self = this;
    const fileReader = new FileReader();
    fileReader.onload = function (event1: any) {
      self.file.data = event1.target.result;
    };
    fileReader.readAsDataURL(event.target.files[0]);
    self.file.name = event.target.files[0].name;
  }

  resetValues() {
    this.isUploading = false;
    this.hasError = false;
    this.errorMessage = null;
    this.isCreated = false;
    this.noEmail = false;
  }

  backToProfile() {
    this.sharedService.navigateToProfile(this.profile, this.router);
  }

  showModal() {
    this.showLicenseModal = true;
  }

  isLoggedIn() {
    return this.userService.isLoggedIn();
  }

  isBuyer() {
    return this.userService.isBuyer();
  }

  isReseller() {
    return this.userService.isReseller();
  }

  isAdmin() {
    return this.userService.isSuperAdmin();
  }

  showLoginModal() {
    this.loginModal.config.backdrop = false;
    this.isLoginModal = true;
    this.loginModal.show();
  }

  public hideLoginModal(): void {
    this.loginModal.hide();
    this.isLoginModal = false;
  }

  public showLoginAlert() {
    if (this.userService.isBuyer()) {
      AlertMessageComponent.open(AlertType.Success, 'Logged in successfully.');
      this.ngOnInit();
    } else {
      this.userService.logout(false);
      AlertMessageComponent.open(AlertType.Error, 'Please login as a buyer in order to request a quote!');
    }
  }

  public showRFQCreatedAlert() {
    AlertMessageComponent.open(AlertType.Success, 'Your request for quotation has been submitted successfully!');
  }

  dateSelected(event) {
    this.quote.date = event;
    console.log(this.quote.date);
  }

  onChangeQuoteStatus(event) {
    console.log(this.quote.status);
  }

  updateSelectedItems() {
    this.selectedItems = [];
    for (const key in this.optionsModel.quoteOptions) {
      if (this.optionsModel.quoteOptions.hasOwnProperty(key)) {
        this.selectedItems.push(this.optionsModel.quoteOptions[key].id);
      }
    }
  }

  public showResellerProgramsModal(): void {
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/rfq/rfq.component.ts